import SoleIcon from '~/assets/icons/Sole';
import useRegion from '~/hooks/useRegion';

import FollowUs from './FollowUs';
import FooterColumn from './FooterColumn';
import { FooterNav, LegalNav } from './FooterNav';
import GetInTouch from './GetInTouch';
import GetTheApp from './GetTheApp';
import { DISCOVER_LINKS, getLegalLinks } from './links';

const today = new Date();

const copyrightText = `© ${today.getUTCFullYear()} Sole Supplier®. All rights reserved. Company Reg No. 09098756`;

const MOBILE_SECOND_ROW_CLASS = 'order-1 desktop:order-none';

const Footer = () => {
  const { code } = useRegion();
  const isGb = code === 'GB';

  return (
    <footer
      className="bg-black font-heading text-sm font-semibold leading-5 tracking-[-0.56px] text-white"
      role="contentinfo"
    >
      <div className="content-width flex flex-col gap-6 py-12 md:py-16">
        <div className="grid grid-cols-2 gap-x-4 gap-y-6 md:gap-x-8 desktop:grid-cols-4">
          {isGb && (
            <FooterColumn title="Discover">
              <FooterNav label="Discover" links={DISCOVER_LINKS} />
            </FooterColumn>
          )}

          {isGb && (
            <FooterColumn
              className={MOBILE_SECOND_ROW_CLASS}
              title="Get in touch"
            >
              <GetInTouch />
            </FooterColumn>
          )}

          <FooterColumn title="Follow us">
            <FollowUs />
          </FooterColumn>

          {isGb && (
            <FooterColumn
              className={MOBILE_SECOND_ROW_CLASS}
              title="Get the app"
            >
              <GetTheApp />
            </FooterColumn>
          )}
        </div>

        <div className="flex flex-col items-center gap-4 desktop:flex-row desktop:gap-8">
          <SoleIcon width="40" height="31" />
          <LegalNav label="Legal" links={getLegalLinks(code)} />
          <p className="text-center font-body text-xs font-normal tracking-[0.24px] text-grey-hide">
            {copyrightText}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
